import {PromoCode} from '@domain/model/Order/PromoCode';
import {PromoRepository, ValidatePromoCodeProps} from '@domain/model/Order/PromoRepository';

import {DEFAULT_HEADERS} from '@infra/domain/model/_utils/defaultHeaders';
import {getAuthHeader} from '@infra/api/authManager/authManager';
import {fetch} from '@infra/api/fetch';

import {PromoCodeResponse} from './ApiOrderRepository';
import {DEVICE, SERVICE} from '@domain/model/Account/PromoCode/PromoCodeRepository';

const APPLY_PROMO_URL = '/api/v2/boxrequest/applyPromocode';
const REMOVE_PROMO_URL = '/web/api/v1/boxrequest/promocode';

const applyPromoCode = async ({
  promocode,
  device = DEVICE.WEB,
  service = SERVICE.BOX,
}: ValidatePromoCodeProps): Promise<PromoCode> => {
  const authHeader = await getAuthHeader();
  const requestBody = {promocode, device, service};

  try {
    const result = await fetch(APPLY_PROMO_URL, {
      method: 'PUT',
      body: JSON.stringify(requestBody),
      headers: {
        ...authHeader,
        ...DEFAULT_HEADERS,
      },
    });
    const response: PromoCodeResponse = await result.json();
    if (!result.ok) {
      return Promise.reject(response);
    }
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

const removePromoCode = async (): Promise<void> => {
  const authHeader = await getAuthHeader();

  try {
    const result = await fetch(REMOVE_PROMO_URL, {
      method: 'DELETE',
      headers: {...authHeader, ...DEFAULT_HEADERS},
    });

    if (!result.ok) {
      const response: {error_message: string} = await result.json();
      return Promise.reject(new Error(response.error_message));
    }

    return Promise.resolve();
  } catch (error) {
    return Promise.reject(error);
  }
};

const ApiPlaceOrderRepository: PromoRepository = {
  applyPromoCode,
  removePromoCode,
};

export {ApiPlaceOrderRepository};
